/* IH PDP section kit — shared behaviours.
   Every init is idempotent + scoped to a root element, and re-runs on
   shopify:section:load so the theme editor stays live-editable. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    if (amount.slice(-3) === '.00') amount = amount.slice(0, -3);
    return (format || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  /* after a successful add: notify the theme, then either open the side cart
     (UpCart drawer — it also auto-opens via its fetch interceptor), go to the
     full cart page, or stay put, per the section's "After add to cart" setting */
  function afterAtc(box) {
    var mode = (box && box.dataset && box.dataset.redirect) || 'drawer';
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (mode === 'cart') { window.location.href = '/cart'; return; }
    if (mode !== 'stay' && typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
  }
  /* SAFETY NET: Kaching's checkout function must zero every deal gift line.
     If the deal's published widget config and its checkout-function config drift
     apart (seen 2026-07-21: function compiled from an unpublished draft), gift
     lines arrive UNRECOGNISED and the customer is charged full price for them.
     This sweep removes any priced gift line and records what the order is still
     owed as a cart attribute so fulfilment can honour the offer manually.
     While Kaching prices gifts at $0 (the healthy state) it is a pure no-op. */
  function guardGiftLines(giftMap) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = [];
        (cart.items || []).forEach(function (it) {
          if (!it.properties || !it.properties.__kaching_bundles) return;
          try {
            var p = JSON.parse(it.properties.__kaching_bundles);
            if (p.gift && it.final_line_price > 0) bad.push({ key: it.key, gift: p.gift });
          } catch (e) {}
        });
        if (!bad.length) return null;
        var updates = {}, owed = [];
        bad.forEach(function (b) {
          updates[b.key] = 0;
          var t = (giftMap && giftMap[b.gift]) || 'free gift';
          if (owed.indexOf(t) === -1) owed.push(t);
        });
        /* one /cart/update.js call: removes the priced gift lines + stamps the
           order note (deliberately NOT /cart/change.js — app fetch interceptors
           rewrite that endpoint) */
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates, attributes: { 'FREE GIFTS OWED (add to this order)': owed.join(' + ') } })
        });
      })
      .catch(function (e) { console.warn('[ih-pdp] gift guard failed', e); });
  }

  /* ---------- countdown ---------- */
  function initCountdown(root) {
    $$('[data-ihp-countdown]', root).forEach(initOneCountdown);
  }
  function initOneCountdown(el) {
    if (!el || el.dataset.ihpInit) return;
    el.dataset.ihpInit = '1';
    var mode = el.dataset.mode || 'daily';
    var fixed = el.dataset.until ? new Date(el.dataset.until.replace(' ', 'T')) : null;
    var h = $('[data-cd-h]', el), m = $('[data-cd-m]', el), s = $('[data-cd-s]', el);
    function tick() {
      var now = new Date(), end;
      if (mode === 'fixed' && fixed && !isNaN(fixed)) { end = fixed; }
      else { end = new Date(now); end.setHours(24, 0, 0, 0); }
      var d = Math.max(0, end - now);
      var hh = Math.floor(d / 3.6e6), mm = Math.floor(d % 3.6e6 / 6e4), ss = Math.floor(d % 6e4 / 1e3);
      if (mode === 'fixed' && hh > 99) hh = 99;
      if (h) h.textContent = String(hh).padStart(2, '0');
      if (m) m.textContent = String(mm).padStart(2, '0');
      if (s) s.textContent = String(ss).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- product gallery ---------- */
  function initGallery(root) {
    $$('[data-ihp-gallery]', root).forEach(initOneGallery);
  }
  function initOneGallery(g) {
    if (!g || g.dataset.ihpInit) return;
    g.dataset.ihpInit = '1';

    /* sticky gallery column: pin near the top when it fits the viewport; when
       taller (e.g. UGC videos enabled), pin with its BOTTOM in view instead so
       every part of the column stays reachable while the info side scrolls */
    var sticky = $('[data-gallery-sticky]', g);
    if (sticky) {
      var calcSticky = function () {
        if (window.innerWidth < 990) { sticky.style.top = ''; return; }
        var h = sticky.offsetHeight, vh = window.innerHeight;
        sticky.style.top = (h + 48 > vh ? Math.min(24, vh - h - 24) : 24) + 'px';
      };
      window.addEventListener('resize', calcSticky, { passive: true });
      $$('img, video', sticky).forEach(function (m) {
        m.addEventListener('load', calcSticky, { once: true });
        m.addEventListener('loadedmetadata', calcSticky, { once: true });
      });
      calcSticky();
      setTimeout(calcSticky, 900);
    }

    var viewport = $('[data-gallery-viewport]', g);
    var slides = $$('[data-gallery-slide]', g);
    var thumbs = $$('[data-gallery-thumb]', g);
    var dots = $$('[data-gallery-dot]', g);
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }
    /* Deterministic horizontal scroll. The theme sets `scroll-behavior: smooth`
       on <html>, and .ihp-thumbs__row inherits it — with that inherited, BOTH
       scrollTo({behavior:'auto'}) and a plain scrollLeft assignment animate
       instead of jumping, and the animation does not reliably land (measured
       2026-07-26: the strip still read scrollLeft 0 after every arrow click,
       while an explicit instant scroll moved it immediately). Overriding
       scroll-behavior inline for the assignment makes it instant and
       dependable — the same feel the thumbnail clicks have always had. Only
       programmatic scrolls are affected; finger/wheel scrolling is untouched. */
    function scrollX(el, left) {
      if (!el) return;
      var keep = el.style.scrollBehavior;
      el.style.scrollBehavior = 'auto';
      el.scrollLeft = left;
      el.style.scrollBehavior = keep;
    }
    var row = $('[data-thumbs-row]', g);
    /* keep the active thumbnail inside the visible part of the strip */
    function revealThumb(i) {
      if (!row || !thumbs[i]) return;
      var tr = thumbs[i].getBoundingClientRect(), rr = row.getBoundingClientRect();
      if (!rr.width) return;
      var delta = 0;
      if (tr.left < rr.left) delta = tr.left - rr.left - 8;
      else if (tr.right > rr.right) delta = tr.right - rr.right + 8;
      if (delta) scrollX(row, row.scrollLeft + delta);
    }
    /* programmatic navigation, exposed on the element so the Kaching bundle
       sync can drive the gallery (see kxSyncFrom). Slides 2+ are loading="lazy"
       and a horizontal scroller counts them as off-screen, so promote the
       target before scrolling or the pack shot arrives blank. */
    function goTo(i, smooth, _try) {
      if (!viewport || !slides.length) return;
      if (isNaN(i)) return;
      i = Math.max(0, Math.min(i, slides.length - 1));
      var im = slides[i].querySelector('img');
      if (im && im.getAttribute('loading') === 'lazy') im.setAttribute('loading', 'eager');
      if (smooth) viewport.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      else scrollX(viewport, slides[i].offsetLeft);
      setActive(i);
      revealThumb(i);
      /* First-paint retry. The bundle sync fires as soon as the Kaching widget
         binds, which can beat the gallery images having any layout — while the
         slides are unsized EVERY slide reports offsetLeft 0, so the scroll
         silently goes nowhere and the hero stays on image 1 (exactly the
         "loads just one product" bug reported 2026-07-26). Retry only while
         that telltale holds, so this can never fight a shopper who has swiped:
         once the offsets are real the condition is false and we stop. */
      if (i > 0 && slides[i].offsetLeft === 0 && (_try || 0) < 12) {
        var t = (_try || 0) + 1;
        setTimeout(function () { goTo(i, false, t); }, 80 * t);
      }
    }
    g.ihpGoTo = goTo;
    g.ihpSlideCount = slides.length;
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i, false); });
    });
    /* dots go through goTo, not a smooth scrollTo: the viewport is
       scroll-snap-type: x mandatory and a smooth programmatic scroll inside it
       never lands, so a dot click used to move the highlight but not the image. */
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i, false); });
    });
    /* The arrows advance the MAIN image, which is what a next/prev control is
       expected to do. They used to nudge the thumbnail strip sideways by 190px
       and never touch the hero at all — so whenever the strip already fitted,
       or its inherited smooth scroll swallowed the nudge, they looked dead.
       Wraps at both ends so the control is never a no-op click. */
    /* Read the index off the real scroll position rather than trusting the
       tracked one, so the arrows stay correct even if `current` has drifted
       (a swipe that never fired a settled scroll event, a mid-load resize). */
    function liveIndex() {
      var w = viewport ? viewport.clientWidth : 0;
      if (!w) return current;
      return Math.max(0, Math.min(Math.round(viewport.scrollLeft / w), slides.length - 1));
    }
    var prev = $('[data-thumbs-prev]', g), next = $('[data-thumbs-next]', g);
    if (prev) prev.addEventListener('click', function () {
      var i = liveIndex();
      goTo(i <= 0 ? slides.length - 1 : i - 1, false);
    });
    if (next) next.addEventListener('click', function () {
      var i = liveIndex();
      goTo(i >= slides.length - 1 ? 0 : i + 1, false);
    });
    if (viewport) viewport.addEventListener('scroll', function () {
      /* Bail while the gallery has no width. The old `|| 1` fallback divided
         scrollLeft by 1 and produced an index in the thousands, clamped to the
         LAST slide — silently corrupting `current`, so the first arrow click
         afterwards jumped to the end of the gallery instead of advancing one. */
      var w = viewport.clientWidth;
      if (!w) return;
      var i = Math.round(viewport.scrollLeft / w);
      setActive(Math.max(0, Math.min(i, slides.length - 1)));
    }, { passive: true });
    setActive(0);
  }

  /* ---------- buy box offers ---------- */
  function initBuyBox(root) {
    $$('[data-ihp-buybox]', root).forEach(initOneBuyBox);
  }
  function initOneBuyBox(box) {
    if (!box || box.dataset.ihpInit) return;
    box.dataset.ihpInit = '1';

    /* delivery date runs regardless of offer setup (incl. Kaching widget mode).
       Counts BUSINESS days only — no shipping on weekends, so the shown date
       can never land on (or count) a Saturday or Sunday. */
    $$('[data-ihp-delivery-date]', box).forEach(function (el) {
      var days = parseInt(el.dataset.days || '3', 10);
      var dd = new Date(), added = 0;
      while (added < days) {
        dd.setDate(dd.getDate() + 1);
        if (dd.getDay() !== 0 && dd.getDay() !== 6) added++;
      }
      var names = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      el.textContent = names[dd.getDay()] + ', ' + months[dd.getMonth()] + ' ' + dd.getDate();
    });

    if ($('[data-ihp-kx]', box)) return; /* custom Kaching selector owns this box (see initKaching) */

    var offers = $$('[data-ihp-offer]', box);
    if (!offers.length) return; /* Kaching-widget mode: native form submit, app handles the rest */
    var variants = [];
    try { variants = JSON.parse(($('[data-ihp-variants]', box) || {}).textContent || '[]'); } catch (e) {}
    var fmt = box.dataset.moneyFormat || '${{amount}}';
    var subToggle = $('[data-ihp-subtoggle] input', box);
    function subOn() { return subToggle ? subToggle.checked : null; }

    function offerData(offer) {
      var vIndex = parseInt(offer.dataset.variantIndex || '1', 10) - 1;
      var v = variants[vIndex] || variants[0] || null;
      var qty = parseInt(offer.dataset.qty || '1', 10);
      var price = offer.dataset.price;      /* manual display override */
      var compare = offer.dataset.compare;
      var useSub = subToggle ? (subOn() && v && v.plan_id) : false;
      if (!price && v) {
        var unit = useSub && v.plan_price ? v.plan_price : v.price;
        price = money(unit * qty, fmt);
      }
      if (!compare && v) {
        var compCents = v.compare_at_price ? v.compare_at_price * qty : (useSub && v.plan_price ? v.price * qty : 0);
        compare = compCents ? money(compCents, fmt) : '';
      }
      var plan = '';
      if (subToggle) { plan = useSub ? String(v.plan_id) : ''; }
      else { plan = offer.dataset.sellingPlan || ''; }
      return { variant: v, qty: qty, price: price || '', compare: compare || '', save: offer.dataset.save || '', level: parseInt(offer.dataset.level || '1', 10), sellingPlan: plan };
    }

    function paintOffer(offer) {
      var d = offerData(offer);
      if (!offer.dataset.price) {
        var pEl = $('[data-offer-price-el]', offer);
        if (pEl) pEl.textContent = d.price;
      }
      if (!offer.dataset.compare) {
        var cEl = $('[data-offer-compare-el]', offer);
        if (cEl) { cEl.textContent = d.compare; cEl.style.display = d.compare ? '' : 'none'; }
      }
    }

    function select(offer) {
      offers.forEach(function (o) {
        var on = o === offer;
        o.classList.toggle('is-active', on);
        var input = $('input', o); if (input) input.checked = on;
      });
      var d = offerData(offer);
      var priceNow = $('[data-ihp-price-now]', box), priceWas = $('[data-ihp-price-was]', box), priceSave = $('[data-ihp-price-save-amount]', box);
      if (priceNow && d.price) priceNow.textContent = d.price;
      if (priceWas) { priceWas.textContent = d.compare; priceWas.style.display = d.compare ? '' : 'none'; }
      if (priceSave) priceSave.textContent = d.save;
      var atcNow = $('[data-ihp-atc-now]', box), atcWas = $('[data-ihp-atc-was]', box);
      if (atcNow && d.price) atcNow.textContent = d.price;
      if (atcWas) { atcWas.textContent = d.compare; atcWas.style.display = d.compare ? '' : 'none'; }
      $$('[data-ihp-gift-tier]', box).forEach(function (tier) {
        var need = parseInt(tier.dataset.unlockAt || '1', 10);
        var unlocked = d.level >= need;
        tier.classList.toggle('is-unlocked', unlocked);
        tier.classList.toggle('is-locked', !unlocked);
      });
      box.dataset.selectedVariant = d.variant ? d.variant.id : '';
      box.dataset.selectedQty = d.qty;
      box.dataset.selectedSellingPlan = d.sellingPlan;
    }

    var current = null;
    offers.forEach(function (o) {
      paintOffer(o);
      o.addEventListener('click', function () { current = o; select(o); });
    });
    var preselected = offers.filter(function (o) { return o.dataset.preselected === 'true'; })[0] || offers[0];
    current = preselected;
    select(preselected);
    if (subToggle) subToggle.addEventListener('change', function () {
      offers.forEach(paintOffer);
      if (current) select(current);
    });

    var atc = $('[data-ihp-atc]', box);
    if (atc && offers.length) atc.addEventListener('click', function (e) {
      e.preventDefault();
      var id = box.dataset.selectedVariant, qty = parseInt(box.dataset.selectedQty || '1', 10);
      var plan = box.dataset.selectedSellingPlan;
      if (!id) { window.location.href = '/cart'; return; }
      atc.setAttribute('disabled', 'disabled');
      var payload = { id: Number(id), quantity: qty };
      if (plan) payload.selling_plan = Number(plan);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('atc');
        afterAtc(box);
      }).catch(function (e) { console.warn('[ih-pdp] add to cart failed', e); })
        .finally(function () { atc.removeAttribute('disabled'); });
    });

  }

  /* ---------- shared mobile card slider (reviews / testimonial wall) ---------- */
  function initCardSliders(root) {
    $$('[data-ihp-cardslider]', root).forEach(function (track) {
      if (track.dataset.ihpInit) return;
      track.dataset.ihpInit = '1';
      var cards = Array.prototype.slice.call(track.children);
      if (cards.length < 2) return;

      var nav = document.createElement('div');
      nav.className = 'ihp-cardslider__nav';
      var dots = document.createElement('div');
      dots.className = 'ihp-cardslider__dots';
      var dotEls = cards.map(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { goTo(i); });
        dots.appendChild(b);
        return b;
      });
      nav.appendChild(dots);

      var prevBtn = null, nextBtn = null;
      if (track.hasAttribute('data-cardslider-arrows')) {
        var arrows = document.createElement('div');
        arrows.className = 'ihp-cardslider__arrows';
        prevBtn = document.createElement('button');
        prevBtn.type = 'button'; prevBtn.setAttribute('aria-label', 'Previous');
        prevBtn.innerHTML = '<svg viewBox="0 0 12 12" fill="none"><path d="M8 1 3 6l5 5" stroke="currentColor" stroke-width="1.6"/></svg>';
        nextBtn = document.createElement('button');
        nextBtn.type = 'button'; nextBtn.setAttribute('aria-label', 'Next');
        nextBtn.innerHTML = '<svg viewBox="0 0 12 12" fill="none"><path d="M4 1l5 5-5 5" stroke="currentColor" stroke-width="1.6"/></svg>';
        prevBtn.addEventListener('click', function () { goTo(current - 1); });
        nextBtn.addEventListener('click', function () { goTo(current + 1); });
        arrows.appendChild(prevBtn); arrows.appendChild(nextBtn);
        nav.appendChild(arrows);
      }
      track.parentNode.insertBefore(nav, track.nextSibling);

      var current = 0;
      function goTo(i) {
        i = Math.max(0, Math.min(i, cards.length - 1));
        var c = cards[i];
        var left = track.scrollLeft + (c.getBoundingClientRect().left - track.getBoundingClientRect().left) - (track.clientWidth - c.clientWidth) / 2;
        track.scrollTo({ left: left, behavior: 'smooth' });
      }
      function update() {
        ticking = false;
        var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        cards.forEach(function (c, i) {
          var r = c.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        current = best;
        dotEls.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
        if (prevBtn) prevBtn.disabled = best === 0;
        if (nextBtn) nextBtn.disabled = best === cards.length - 1;
      }
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* ---------- compounds: phone carousel progress ---------- */
  function initCompounds(root) {
    $$('[data-ihp-compounds]', root).forEach(function (sec) {
      if (sec.dataset.ihpCarouselInit) return;
      sec.dataset.ihpCarouselInit = '1';
      var track = $('[data-compounds-track]', sec);
      var progress = $('[data-compounds-progress]', sec);
      if (!track || !progress) return;
      var segs = $$('.ihp-compounds__segs i', sec);
      var counter = $('[data-compounds-current]', sec);
      var items = $$('.ihp-compounds__item', sec);
      var ticking = false;
      function update() {
        ticking = false;
        var tRect = track.getBoundingClientRect();
        var mid = tRect.left + tRect.width / 2;
        var best = 0, bestDist = Infinity;
        items.forEach(function (it, i) {
          var r = it.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        segs.forEach(function (s, i) { s.classList.toggle('is-done', i <= best); });
        if (counter) counter.textContent = best + 1;
      }
      track.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* ---------- custom Kaching-driven bundle selector ----------
     Renders a Resilia-style offer picker from the live Kaching deal config on the
     page, and drives add-to-cart by writing the exact `__kaching_bundles` line
     properties the Kaching widget writes — so the deal's gifts + discount apply at
     checkout. Content (titles/prices/gifts/ribbons) comes from the deal, so editing
     the deal in Kaching updates this selector automatically. Falls back to Kaching's
     own <kaching-bundle> widget if the deal config can't be read. */
  function gidNum(s) { return s ? Number(String(s).split('/').pop()) : null; }
  /* Kaching gift images are configured as MediaImage GIDs the storefront can't resolve;
     these are the current ones (resolved via Admin API). Unknown GIDs fall back to the
     gift product's own image, so new gifts still get a picture. */
  var KX_GIFT_IMGS = {
    39449126338818: 'https://cdn.shopify.com/s/files/1/0801/8595/0466/files/Kaching-Bundles-Screenshot_2026-05-28_at_12.36_Background_Removed.59_pm_645f8aad-71aa-4094-9043-f2714c69dd40.png?v=1780292816&width=96',
    39449089835266: 'https://cdn.shopify.com/s/files/1/0801/8595/0466/files/Kaching-Bundles-1779853756353-4xf6gu2y0vu_Background_Removed.png?v=1780292558&width=96'
  };
  var KX_BOX_ICON = '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M16 4 5 9v13l11 5 11-5V9L16 4z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M5 9l11 5 11-5M16 14v13" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="24" cy="24" r="6.5" fill="#22A861" stroke="#fff" stroke-width="1.5"/><path d="m21.4 24 1.8 1.8 3-3.1" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function kxRandId() {
    var c = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789', o = 'k';
    for (var i = 0; i < 5; i++) o += c[Math.floor((performance.now() * (i + 7) * 31) % c.length)];
    return o;
  }
  function kxParseDeal(productId) {
    var tag = document.querySelector('script.kaching-bundles-deal-block-settings');
    if (!tag) return null;
    var dbs; try { dbs = JSON.parse(tag.textContent); } catch (e) { return null; }
    if (!dbs || !dbs.dealBars || !dbs.dealBars.length) return null;
    var prodTags = $$('script.kaching-bundles-product').map(function (s) { try { return JSON.parse(s.textContent); } catch (e) { return null; } }).filter(Boolean);
    var productById = {}; prodTags.forEach(function (p) { productById[p.id] = p; });
    /* the deal-block-settings JSON has no productId; take it from this buy box's
       <kaching-bundle> element, falling back to the app's config script tag */
    var dealProductId = productId;
    if (!dealProductId) {
      var cfg = document.querySelector('script.kaching-bundles-config');
      try { dealProductId = cfg ? JSON.parse(cfg.textContent).productId : null; } catch (e) {}
    }
    dealProductId = Number(dealProductId);
    var mainProd = productById[dealProductId];
    if (!mainProd) return null;
    var adjById = {};
    (mainProd.sellingPlans || []).forEach(function (sp) { if (sp.priceAdjustment) adjById[sp.id] = sp.priceAdjustment; });
    var barVars = {};
    (dbs.defaultVariantsV2 || []).forEach(function (dv) {
      if (gidNum(dv.productGID) === dealProductId) barVars[dv.dealBarId] = (dv.variantGIDs || []).map(gidNum);
    });
    var bars = dbs.dealBars.map(function (b) {
      var vids = barVars[b.id] || [];
      var mainVariant = vids[0] || mainProd.selectedVariantId;
      var mv = (mainProd.variants || []).filter(function (v) { return v.id === mainVariant; })[0] || null;
      var plan = mv && mv.sellingPlans && mv.sellingPlans[0] ? mv.sellingPlans[0].id : null;
      var adj = (plan && adjById[plan]) ? adjById[plan] : { type: 'percentage', value: 20 };
      var gifts = (b.freeGifts || []).map(function (g) {
        var pid = gidNum(g.productGID), vId = (g.variantGIDs && g.variantGIDs[0]) ? gidNum(g.variantGIDs[0]) : null;
        if (!vId) { vId = (pid === dealProductId) ? mainVariant : ((productById[pid] && productById[pid].variants && productById[pid].variants[0]) ? productById[pid].variants[0].id : null); }
        /* visual value data for the gift row: Kaching's configured gift image when we
           know it, else the gift product's own image; value = its first variant's
           compare-at (or price) so shoppers see what the freebie is worth */
        var gp = productById[pid];
        var gv0 = gp && gp.variants && gp.variants[0] ? gp.variants[0] : null;
        var mediaNum = g.mediaImageGID ? gidNum(g.mediaImageGID) : null;
        var img = (mediaNum && KX_GIFT_IMGS[mediaNum]) || (gp && gp.image ? ('https:' + gp.image).replace('https:https:', 'https:') : '');
        var value = gv0 ? Math.max(gv0.compareAtPrice || 0, gv0.price || 0) * (g.quantity || 1) : 0;
        return { id: g.id, text: g.text, variantId: vId, subOnly: !!g.applyOnlyForSubscriptions, img: img, value: value };
      }).filter(function (g) { return g.variantId; });
      var oneTime = (b.discountType === 'specific' && typeof b.discountValue === 'number') ? Math.round(b.discountValue * 100) : (mv ? mv.price * b.quantity : 0);
      var sub = adj.type === 'percentage' ? Math.round(oneTime * (1 - adj.value / 100)) : oneTime;
      var compare = mv && mv.compareAtPrice ? mv.compareAtPrice * b.quantity : 0;
      return {
        id: b.id, title: b.title || 'Bundle', subtitle: b.subtitle || '', badge: b.badgeText || '',
        qty: b.quantity, mainVariant: mainVariant, plan: plan, planAdj: adj, gifts: gifts,
        oneTime: oneTime, sub: sub, compare: compare,
        supply: (b.highlights && b.highlights.items ? b.highlights.items.filter(Boolean)[0] : '') || '',
        preselected: b.id === dbs.preselectedDealBarId
      };
    }).filter(function (b) { return b.mainVariant; });
    if (!bars.length) return null;
    var s = dbs.subscriptions || {};
    return {
      deal: dbs.nanoId, v: dbs.versionId, productId: dealProductId, image: mainProd.image ? ('https:' + mainProd.image).replace('https:https:', 'https:') : '',
      subEnabled: !!dbs.subscriptionsEnabled,
      subTitle: s.subscribeTitle || 'Subscribe & Save', subSub: s.subscribeSubtitle || '',
      bars: bars
    };
  }

  /* NATIVE MODE (2026-07-22, Tynan's call): show Kaching's own widget design
     instead of the custom Resilia-style selector. The offer area renders
     Kaching's stock UI and Kaching's script owns add-to-cart via the product
     form. Flip to false to bring the custom selector (+ gift guard) back. */
  var KX_NATIVE_MODE = true;
  function initKaching(root) {
    if (KX_NATIVE_MODE) return; /* leave the native <kaching-bundle> visible */
    $$('[data-ihp-kx]', root).forEach(function (mount) {
      if (mount.dataset.ihpInit) return;
      /* Kaching injects its deal config asynchronously; retry until it's present
         (or give up after ~10s and leave the native widget fallback showing). */
      var nativeEl = $('[data-ihp-kx-native]', mount);
      var pid = nativeEl ? Number(nativeEl.getAttribute('product-id')) : null;
      var tries = 0;
      (function attempt() {
        if (mount.dataset.ihpInit) return;
        if (kxParseDeal(pid)) { renderKaching(mount, pid); return; }
        if (++tries > 40) return;
        setTimeout(attempt, 250);
      })();
    });
  }
  function renderKaching(mount, pid) {
      if (mount.dataset.ihpInit) return;
      var model = kxParseDeal(pid);
      if (!model) return; /* leave the native <kaching-bundle> fallback visible */
      mount.dataset.ihpInit = '1';
      mount.classList.add('ihp-kx--ready'); /* hides the native widget via CSS */

      var box = mount.closest('[data-ihp-buybox]') || document;
      var fmt = (box.dataset && box.dataset.moneyFormat) || '${{amount}}';
      var showImg = mount.dataset.showImages !== 'false';
      var subDefault = mount.dataset.subDefault !== 'false';
      var offerImgs = [];
      try { offerImgs = JSON.parse(mount.dataset.offerImages || '[]') || []; } catch (e) {}
      var uid = 'kx' + Math.floor((performance.now() * 131) % 1e6);

      /* ---- build DOM ---- */
      var wrap = document.createElement('div');
      var offersEl = document.createElement('div'); offersEl.className = 'ihp-offers';
      model.bars.forEach(function (bar, i) {
        var barImg = offerImgs[i] || model.image;
        var lab = document.createElement('label');
        lab.className = 'ihp-offer'; lab.setAttribute('data-kx-offer', bar.id);
        lab.innerHTML =
          (bar.badge ? '<span class="ihp-offer__ribbon">' + escapeHtml(bar.badge) + '</span>' : '') +
          '<span class="ihp-offer__grid">' +
            '<input type="radio" name="' + uid + '">' +
            '<span class="ihp-offer__radio"></span>' +
            (showImg && barImg ? '<img class="ihp-offer__img" src="' + barImg + '" alt="" loading="lazy">' : '') +
            '<span class="ihp-offer__info">' +
              '<strong class="ihp-offer__title">' + escapeHtml(bar.title) + '</strong>' +
              (bar.subtitle ? '<span class="ihp-offer__sub">' + escapeHtml(bar.subtitle) + '</span>' : '') +
            '</span>' +
            '<span class="ihp-offer__prices">' +
              '<span class="ihp-offer__price" data-kx-price></span>' +
              '<span class="ihp-offer__compare" data-kx-compare></span>' +
            '</span>' +
          '</span>' +
          (bar.supply ? '<span class="ihp-offer__supply">' + escapeHtml(bar.supply) + '</span>' : '') +
          (bar.gifts.length ? '<span class="ihp-offer__grows">' + bar.gifts.map(function (g) {
            var t = /^\s*\+/.test(g.text || '') ? g.text : '+ ' + (g.text || 'Free gift');
            return '<span class="ihp-offer__grow">' +
              (g.img ? '<img src="' + g.img + '" alt="" loading="lazy">' : KX_BOX_ICON) +
              '<span class="ihp-offer__growlabel">' + escapeHtml(t) + '</span>' +
              (g.value ? '<s class="ihp-offer__growvalue">' + money(g.value, fmt) + '</s>' : '') +
            '</span>';
          }).join('') + '</span>' : '');
        offersEl.appendChild(lab);
      });
      wrap.appendChild(offersEl);

      var subInput = null;
      if (model.subEnabled) {
        var subLab = document.createElement('label');
        subLab.className = 'ihp-subtoggle';
        subLab.innerHTML =
          '<input type="checkbox" data-kx-sub' + (subDefault ? ' checked' : '') + '>' +
          '<span class="ihp-subtoggle__box" aria-hidden="true"><svg viewBox="0 0 14 12" fill="none"><path d="M1.5 6.5l3.6 3.6L12.5 1.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<span class="ihp-subtoggle__text"><strong>' + escapeHtml(model.subTitle) + '</strong>' + (model.subSub ? '<small>' + escapeHtml(model.subSub) + '</small>' : '') + '</span>' +
          '<span class="ihp-subtoggle__prices"><b data-kx-sub-price></b><s data-kx-sub-compare></s></span>';
        wrap.appendChild(subLab);
        subInput = subLab.querySelector('input');
      }
      /* insert custom UI before the native widget (which CSS now hides) */
      mount.insertBefore(wrap, mount.firstChild);

      /* ---- behaviour ---- */
      var labels = $$('[data-kx-offer]', offersEl);
      function subOn() { return subInput ? subInput.checked : false; }
      function priceFor(bar) { return (subOn() && bar.plan) ? bar.sub : bar.oneTime; }
      function paint() {
        labels.forEach(function (lab, i) {
          var bar = model.bars[i];
          var now = priceFor(bar);
          var pEl = $('[data-kx-price]', lab), cEl = $('[data-kx-compare]', lab);
          if (pEl) pEl.textContent = money(now, fmt);
          var comp = bar.compare && bar.compare > now ? bar.compare : (subOn() && bar.plan ? bar.oneTime : 0);
          if (cEl) { cEl.textContent = comp ? money(comp, fmt) : ''; cEl.style.display = comp ? '' : 'none'; }
        });
      }
      var selected = model.bars.filter(function (b) { return b.preselected; })[0] || model.bars[0];
      function select(bar) {
        selected = bar;
        labels.forEach(function (lab, i) {
          var on = model.bars[i].id === bar.id;
          lab.classList.toggle('is-active', on);
          var r = $('input', lab); if (r) r.checked = on;
        });
        var now = priceFor(bar);
        var comp = bar.compare && bar.compare > now ? bar.compare : (subOn() && bar.plan ? bar.oneTime : 0);
        var pn = $('[data-ihp-price-now]', box), pw = $('[data-ihp-price-was]', box), ps = $('[data-ihp-price-save-amount]', box);
        if (pn) pn.textContent = money(now, fmt);
        if (pw) { pw.textContent = comp ? money(comp, fmt) : ''; pw.style.display = comp ? '' : 'none'; }
        if (ps) {
          var badge = ps.closest('.ihp-price__save');
          var saveAmt = comp && comp > now ? comp - now : 0;
          if (saveAmt) { ps.textContent = money(saveAmt, fmt); if (badge) badge.style.display = ''; }
          else if (badge) badge.style.display = 'none';
        }
        var an = $('[data-ihp-atc-now]', box), aw = $('[data-ihp-atc-was]', box);
        if (an) an.textContent = money(now, fmt);
        if (aw) { aw.textContent = comp ? money(comp, fmt) : ''; aw.style.display = comp ? '' : 'none'; }
        /* subscribe box: this bar's subscription price vs its full value incl. gifts */
        var sp = $('[data-kx-sub-price]', box), sc = $('[data-kx-sub-compare]', box);
        if (sp) {
          if (bar.plan) {
            var giftVal = 0;
            bar.gifts.forEach(function (g) { giftVal += g.value || 0; });
            var valTotal = (bar.compare || bar.oneTime) + giftVal;
            sp.textContent = money(bar.sub, fmt);
            if (sc) { sc.textContent = valTotal > bar.sub ? money(valTotal, fmt) : ''; }
          } else {
            sp.textContent = '';
            if (sc) sc.textContent = '';
          }
        }
      }
      labels.forEach(function (lab, i) { lab.addEventListener('click', function () { select(model.bars[i]); }); });
      if (subInput) subInput.addEventListener('change', function () { paint(); select(selected); });
      paint(); select(selected);

      /* ---- add to cart ---- */
      function buildItems(bar, sub) {
        var G = kxRandId(), items = [];
        /* key order mirrors Kaching's own widget: deal, pp, main, v, id, bid */
        var mainProp = { deal: model.deal, pp: model.productId, main: true, v: model.v, id: G, bid: bar.id };
        var mainLine = { id: bar.mainVariant, quantity: bar.qty, properties: {} };
        if (sub && bar.plan) { mainLine.selling_plan = bar.plan; mainProp.sellingPlan = { id: bar.plan, priceAdjustment: bar.planAdj }; }
        mainLine.properties.__kaching_bundles = JSON.stringify(mainProp);
        items.push(mainLine);
        bar.gifts.forEach(function (g) {
          if (g.subOnly && !sub) return;
          var line = { id: g.variantId, quantity: 1, properties: { __kaching_bundles: JSON.stringify({ id: G, deal: model.deal, v: model.v, gift: g.id }) } };
          if (sub && bar.plan && g.variantId === bar.mainVariant) line.selling_plan = bar.plan;
          items.push(line);
        });
        return items;
      }
      var atc = $('[data-ihp-atc]', box);
      if (atc) {
        atc.type = 'button';
        atc.addEventListener('click', function (e) {
          e.preventDefault();
          if (atc.hasAttribute('disabled')) return;
          atc.setAttribute('disabled', 'disabled');
          /* ONE request with every line, like Kaching's own widget — no per-line lag.
             Shopify lists a multi-item add newest-first (reverse of the array), so the
             array is sent reversed to display as: product first, gifts under it. */
          var items = buildItems(selected, subOn()).reverse();
          var giftMap = {};
          selected.gifts.forEach(function (g) { giftMap[g.id] = g.text; });
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) {
              if (!r.ok) throw new Error('atc ' + r.status);
              return guardGiftLines(giftMap);
            })
            .then(function () { afterAtc(box); })
            .catch(function (err) { console.warn('[ih-pdp] kaching add failed', err); })
            .finally(function () { atc.removeAttribute('disabled'); });
        });
      }
  }
  /* ---------- NATIVE MODE: Kaching bundle -> theme price row + gallery ----------
     ROOT CAUSE of the static magnesium price row (measured live 2026-07-26):
     product.pdp-v2 renders <kaching-bundle> itself from its `kaching` theme
     block, so the element is in the document at DOMContentLoaded and the old
     one-shot $$('kaching-bundle', root) found it. product.magnesium-gummies
     has no `kaching` block, so the app embed injects the widget into .ihp-info
     AFTER DOMContentLoaded, the one-shot query returned an empty list, and
     nothing ever bound. Discovery is therefore an observer, not one query.

     Prices are COPIED from the bar the shopper can see rather than recomputed,
     so Subscribe & Save, sale prices and future deal edits come along free.
     The saving is COMPUTED as was - now: the bars' own "Save $X" subtitles are
     merchant free-text that contradicts their own numbers (bars 2 and 3 both
     read "Save $125" for $64.00 and $96.00), and the badge sits inches from
     the two figures that define it. */

  var KX_DISCOVER_MS = 30000; /* stop watching for a late-injected widget */
  var KX_WARNED = false;

  function initKachingNativeSync(root) {
    if (!KX_NATIVE_MODE) return;
    $$('[data-ihp-buybox]', root).forEach(function (box) {
      if (box.dataset.ihpKxWatch) return;
      box.dataset.ihpKxWatch = '1';
      kxAdopt(box);
      if (typeof MutationObserver === 'undefined') return;
      /* SAFE BY CONSTRUCTION: this callback never writes to the DOM, so the
         sync's own price writes (which land inside this box) cannot loop.
         Scoped to the buy box, not documentElement, so the 1Hz countdown
         ticker on the page does not wake it forever. */
      var obs = new MutationObserver(function () { kxAdopt(box); });
      obs.observe(box, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, KX_DISCOVER_MS);
    });
    if (root !== document) return;
    setTimeout(function () {
      if (KX_WARNED) return;
      if (document.querySelector('kaching-bundle:not([data-ihp-sync])')) {
        KX_WARNED = true;
        console.warn('[ih-pdp] a <kaching-bundle> sits outside every [data-ihp-buybox]; price sync will not run for it');
      }
    }, 8000);
  }

  /* rAF does not run in a hidden document; fall back so a background tab still
     paints its price row before the shopper ever looks at it */
  function kxRaf(fn) {
    if (document.hidden) { setTimeout(fn, 0); } else { requestAnimationFrame(fn); }
  }

  function kxAdopt(box) {
    $$('kaching-bundle', box).forEach(function (widget) {
      if (widget.dataset.ihpSync) return;
      widget.dataset.ihpSync = '1';
      var scheduled = false;
      function sync() { scheduled = false; kxSyncFrom(widget, box); }
      function schedule() { if (!scheduled) { scheduled = true; kxRaf(sync); } }
      /* the widget hydrates and re-renders itself — toggling Subscribe & Save
         repaints the bar prices WITHOUT changing the selected bar, and only the
         observer catches that. Coalesced to one paint per frame. */
      new MutationObserver(schedule).observe(widget, { subtree: true, childList: true, characterData: true, attributes: true });
      widget.addEventListener('click', schedule);
      widget.addEventListener('change', schedule);
      sync();
    });
  }

  /* Only bars carrying a deal-bar id are real bundles. The 4th
     .kaching-bundles__bar on this deal is the "Subscribe & Save | Cancel
     anytime easily" toggle: role=checkbox, no data-deal-bar-id, no price node.
     Deliberately NOT also requiring an input[type=radio] — a bar-design change
     in the Kaching admin could drop the native inputs, and that filter would
     then silently return zero bars and freeze the whole feature. */
  function kxBars(widget) { return $$('.kaching-bundles__bar[data-deal-bar-id]', widget); }

  function kxSelectedBar(bars) {
    var i, r;
    for (i = 0; i < bars.length; i++) {
      if (bars[i].classList.contains('kaching-bundles__bar--selected')) return i;
    }
    for (i = 0; i < bars.length; i++) {
      r = bars[i].querySelector('input[type="radio"]');
      if (r && r.checked) return i;
    }
    return -1;
  }

  /* The bar's OWN price nodes, queried directly on the bar, first match only.
     A [class*="price"] sweep would pick up the free-gift rows
     (.kaching-bundles__free-gift__full-price: $7.95 / $24.00) and price the
     page off a giveaway. Also collapses the trailing space Kaching renders. */
  function kxBarText(bar, sel) {
    var el = bar.querySelector(sel);
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* Cents from a rendered money string, decimal separator detected by position
     so "$1,149.98" and "1.149,98 EUR" both parse. Returns null when there is no
     number to read. The old parser stripped every non [0-9.] character, which
     turned "64,00 EUR" into 640000 — a 100x overstatement in the save badge. */
  function kxCents(text) {
    var m = String(text == null ? '' : text).match(/\d[\d.,\u00A0\u202F ]*\d|\d/);
    if (!m) return null;
    var s = m[0].replace(/[\u00A0\u202F ]/g, '');
    var sep = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
    var dec = '';
    if (sep > -1) {
      var tail = s.slice(sep + 1);
      if (/^\d{1,2}$/.test(tail)) { dec = tail; s = s.slice(0, sep); }
    }
    var whole = s.replace(/[.,]/g, '');
    if (!/^\d+$/.test(whole)) return null;
    return parseInt(whole, 10) * 100 + (dec ? parseInt((dec + '0').slice(0, 2), 10) : 0);
  }

  /* Render `cents` in the same shape as the string it will sit beside: same
     currency affixes, same decimal habit. money() is deliberately NOT used —
     it strips a trailing ".00" (see line 11), which would print "Save $86"
     between "$64.00" and "$149.98". */
  function kxMoneyLike(cents, sample, fmt) {
    var s = String(sample == null ? '' : sample);
    var first = s.search(/\d/);
    if (first < 0) return money(cents, fmt);
    var last = s.search(/\d(?!.*\d)/);
    var pre = s.slice(0, first), post = s.slice(last + 1);
    var dec = (/[.,]\d{2}(?!\d)/.test(s) || (cents % 100) !== 0) ? 2 : 0;
    return pre + (cents / 100).toFixed(dec) + post;
  }

  /* write only on change: keeps the discovery observer quiet and avoids a
     forced style invalidation every time the widget re-renders */
  function kxSetText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function kxSetShown(el, on) {
    if (!el) return;
    var d = on ? '' : 'none';
    if (el.style.display !== d) el.style.display = d;
  }

  /* One token per Kaching bar, in BAR ORDER top to bottom. Blank/absent =
     gallery switching OFF for this section (that is how product.pdp-v2 stays
     untouched). Bar ids are opaque AND duplicated across the NMN and magnesium
     deals, so bar order is the only sane key on the bar side. */
  function kxImageMap(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (!s) return [];
    return s.split(',').map(function (p) { return p.trim(); });
  }

  /* Resolve one map token to a slide index. Two forms, deliberately:
       "3"      -> 1-based gallery position (image 3)
       "2bag"   -> first slide whose image src or alt CONTAINS that text
     The name form exists because positional mapping is a footgun here: on
     2026-07-26 the product media were reordered (the 2-bag and 3-bag shots
     swapped, an 8th image was added) and a "1,2,3" map silently started
     showing three satchels for the 2-bottle bundle. A name survives any
     reorder and only breaks if the file itself is replaced, which is loud.
     Returns -1 when unresolvable, and the caller then leaves the gallery be. */
  function kxResolveSlide(token, gal) {
    if (!token) return -1;
    if (/^\d+$/.test(token)) return parseInt(token, 10) - 1;
    var needle = token.toLowerCase();
    var slides = $$('[data-gallery-slide]', gal);
    for (var i = 0; i < slides.length; i++) {
      var im = slides[i].querySelector('img');
      if (!im) continue;
      var hay = ((im.getAttribute('src') || '') + ' ' + (im.getAttribute('alt') || '')).toLowerCase();
      if (hay.indexOf(needle) > -1) return i;
    }
    return -1;
  }

  function kxSyncFrom(widget, box) {
    var bars = kxBars(widget);
    if (!bars.length) return;                       /* still hydrating */
    var idx = kxSelectedBar(bars);
    if (idx < 0) return;                            /* no bar chosen yet */
    var bar = bars[idx];
    var barId = bar.getAttribute('data-deal-bar-id');

    /* ---------- price row ---------- */
    var nowText = kxBarText(bar, '.kaching-bundles__bar-price');
    var wasText = kxBarText(bar, '.kaching-bundles__bar-full-price');
    var pn = $('[data-ihp-price-now]', box);
    var pw = $('[data-ihp-price-was]', box);
    var ps = $('[data-ihp-price-save-amount]', box);
    var badge = ps ? ps.closest('.ihp-price__save') : null;
    if (nowText) {
      var nowC = kxCents(nowText), wasC = kxCents(wasText);
      /* ONE gate drives both the strikethrough and the badge. Variant
         48223289278722 of this product has compare_at ($74.98) BELOW its price
         ($99.98); showing the compare-at unconditionally renders a struck-out
         number lower than the live price, which reads as a price rise. */
      var showWas = (nowC !== null && wasC !== null && wasC > nowC);
      var fmt = (box.dataset && box.dataset.moneyFormat) || '${{amount}}';
      kxSetText(pn, nowText);
      if (pn && pn.style.visibility) pn.style.visibility = '';
      kxSetText(pw, showWas ? wasText : '');
      kxSetShown(pw, showWas);
      kxSetText(ps, showWas ? kxMoneyLike(wasC - nowC, wasText, fmt) : '');
      kxSetShown(badge, showWas);
      var an = $('[data-ihp-atc-now]', box), aw = $('[data-ihp-atc-was]', box);
      kxSetText(an, nowText);
      kxSetText(aw, showWas ? wasText : '');
      kxSetShown(aw, showWas);
      widget.dataset.ihpBarPainted = barId;
    } else if (widget.dataset.ihpBarPainted && widget.dataset.ihpBarPainted !== barId) {
      /* the selection moved but this bar's price is unreadable: hide rather
         than leave the PREVIOUS bundle's price sitting above Add To Cart */
      if (pn) pn.style.visibility = 'hidden';
      kxSetShown(pw, false);
      kxSetShown(badge, false);
    }

    /* ---------- gallery ---------- */
    /* Runs on the FIRST sync too, so the hero matches the preselected bundle
       on load — landing on "2 Bottles" while the gallery showed the single-bag
       shot read as broken. Still keyed on the bar CHANGING, so an unrelated
       widget re-render (e.g. the Subscribe & Save toggle repricing the bars)
       never yanks a shopper who has manually swiped to another image. */
    var seen = widget.dataset.ihpBarSeen;
    widget.dataset.ihpBarSeen = barId;
    if (seen === barId) return;
    var map = kxImageMap(box.dataset.kxImageMap);
    if (!map.length) return;                        /* setting blank = feature off */
    var gal = $('[data-ihp-gallery]', box);
    if (!gal || typeof gal.ihpGoTo !== 'function') return;
    var slide = (idx < map.length) ? kxResolveSlide(map[idx], gal) : -1;
    if (slide < 0) return;                          /* unmapped/unresolvable: leave the gallery alone */
    if (slide >= (gal.ihpSlideCount || 0)) return;  /* mapped past the end: do nothing */
    /* INSTANT, not smooth. Measured live 2026-07-26: .ihp-gallery__viewport is
       scroll-snap-type: x mandatory, and a programmatic smooth scroll inside it
       never lands — scrollLeft stays put while the snap cancels the animation.
       An instant scrollTo to the same offset works every time, which is why the
       thumbnail handler above already uses behavior:'auto'. (Same reason the
       dot buttons, which still ask for 'smooth', do not actually move the hero.) */
    gal.ihpGoTo(slide, false);
  }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- stock bars: animate when scrolled into view ---------- */
  function initStockBars(root) {
    $$('[data-ihp-stock]', root).forEach(function (bar) {
      if (bar.dataset.ihpInit) return;
      bar.dataset.ihpInit = '1';
      var r = bar.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { bar.classList.add('is-inview'); return; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { bar.classList.add('is-inview'); obs.disconnect(); }
          });
        }, { threshold: .5 }).observe(bar);
      } else { bar.classList.add('is-inview'); }
    });
  }

  /* ---------- accordions (buy box + anywhere) ---------- */
  function initAccordions(root) {
    $$('[data-ihp-acc]', root).forEach(function (item) {
      if (item.dataset.ihpInit) return;
      item.dataset.ihpInit = '1';
      var btn = $('[data-ihp-acc-btn]', item), panel = $('[data-ihp-acc-panel]', item);
      function set(open) {
        item.classList.toggle('is-open', open);
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      btn.addEventListener('click', function () { set(!item.classList.contains('is-open')); });
      if (item.dataset.open === 'true') set(true);
    });
  }

  /* ---------- count-up stats ---------- */
  function initCounters(root) {
    $$('[data-ihp-count]', root).forEach(function (el) {
      if (el.dataset.ihpInit) return;
      el.dataset.ihpInit = '1';
      var target = parseFloat((el.dataset.ihpCount || '0').replace(/,/g, '')) || 0;
      var dur = 1400, started = false;
      function run() {
        if (started) return; started = true;
        var t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          el.textContent = val.toLocaleString('en-US');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (en) { if (en.isIntersecting) { run(); obs.disconnect(); } });
        }, { threshold: .4 }).observe(el);
      } else { run(); }
    });
  }

  /* ---------- reasons carousel ---------- */
  function initReasons(root) {
    $$('[data-ihp-reasons]', root).forEach(function (sec) {
      if (sec.dataset.ihpInit) return;
      sec.dataset.ihpInit = '1';
      var track = $('[data-reasons-track]', sec);
      var cards = $$('.ihp-reasons__card', sec);
      var prev = $('[data-reasons-prev]', sec), next = $('[data-reasons-next]', sec);
      var dotsWrap = $('[data-reasons-dots]', sec);
      var index = 0;
      function perView() { return window.innerWidth <= 749 ? 1 : window.innerWidth <= 989 ? 2 : 3; }
      function maxIndex() { return Math.max(0, cards.length - perView()); }
      function go(i) {
        index = Math.max(0, Math.min(i, maxIndex()));
        var gap = 24;
        var w = cards[0] ? cards[0].getBoundingClientRect().width + gap : 0;
        track.style.transform = 'translateX(' + (-index * w) + 'px)';
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === maxIndex();
        $$('button', dotsWrap).forEach(function (d, j) { d.classList.toggle('is-active', j === index); });
      }
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i <= maxIndex(); i++) (function (i) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', function () { go(i); });
          dotsWrap.appendChild(b);
        })(i);
      }
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      window.addEventListener('resize', function () { go(index); });
      go(0);
    });
  }

  /* ---------- horizontal video strips ---------- */
  function initStrips(root) {
    $$('[data-ihp-strip]', root).forEach(function (strip) {
      if (strip.dataset.ihpInit) return;
      strip.dataset.ihpInit = '1';
      var row = $('[data-strip-row]', strip);
      var prev = $('[data-strip-prev]', strip), next = $('[data-strip-next]', strip);
      var step = parseInt(strip.dataset.step || '472', 10);
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step, behavior: 'smooth' }); });
    });
  }

  /* ---------- videos: native controls + in-view autoplay ---------- */
  function initVideos(root) {
    $$('[data-ihp-video-tile]', root).forEach(function (tile) {
      if (tile.dataset.ihpInit) return;
      tile.dataset.ihpInit = '1';
      var video = $('video', tile), btn = $('[data-video-play]', tile);
      if (!video) return;
      video.addEventListener('play', function () { tile.classList.add('is-playing'); });
      video.addEventListener('pause', function () { tile.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { tile.classList.remove('is-playing'); });
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); markUserPlay(video); video.play().catch(function () {}); });
      if (tile.dataset.autoplay === 'true') {
        video.muted = true;
        var userTookOver = false;
        video.addEventListener('pointerdown', function () { userTookOver = true; });
        video.addEventListener('volumechange', function () { userTookOver = true; });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (userTookOver) return;
              if (en.isIntersecting) { video.play().catch(function () {}); }
              else { video.pause(); }
            });
          }, { threshold: .25 }).observe(tile);
        } else { video.play().catch(function () {}); }
      }
    });
  }

  /* ---------- one video at a time ----------
     Bound once at document level in the CAPTURE phase, because `play` does not
     bubble. That covers every <video> on the page — UGC strip under the gallery,
     the testimonial strip, gallery media — with no per-tile wiring, so sections
     added later in the editor are handled too.
     A muted in-view autoplay loop is ambient, not a choice: it must never cut off
     something the visitor deliberately started, so it yields instead. */
  var activeVideo = null;

  /* Autoplay tiles ship muted+loop so they can sit there as ambient wallpaper.
     The moment the visitor chooses to watch one it has to behave like a real
     video: sound on, and stop at the end instead of looping forever.
     Unmuting happens HERE, synchronously inside the pointer/click gesture —
     do it later (say, in the play handler) and the autoplay policy can suspend
     playback for unmuting without a user gesture. Once only, so a visitor who
     deliberately hits mute afterwards is not overridden. */
  function markUserPlay(video) {
    if (!video) return;
    video.dataset.ihpUserPlay = '1';
    if (video.dataset.ihpUnmuted === '1') return;
    var tile = video.closest('[data-ihp-video-tile]');
    if (!tile || tile.dataset.autoplay !== 'true') return;
    video.dataset.ihpUnmuted = '1';
    video.muted = false;
    video.loop = false;
  }

  /* drop "Download" from the native controls overflow menu. Belt-and-braces with
     the controlslist attribute in the section markup, and it also reaches videos
     this kit did not render (gallery media, anything added later). */
  function initVideoControls(root) {
    $$('video', root).forEach(function (v) { v.setAttribute('controlsList', 'nodownload'); });
  }

  function isAmbient(video) {
    if (video.dataset.ihpUserPlay === '1') return false;
    var tile = video.closest('[data-ihp-video-tile]');
    return !!tile && tile.dataset.autoplay === 'true';
  }

  function initVideoSolo() {
    if (document.documentElement.dataset.ihpVideoSolo) return;
    document.documentElement.dataset.ihpVideoSolo = '1';

    /* native controls sit in shadow DOM, so hitting play there targets the <video> */
    document.addEventListener('pointerdown', function (e) {
      var video = e.target && e.target.closest ? e.target.closest('video') : null;
      if (video) markUserPlay(video);
    }, true);

    document.addEventListener('play', function (e) {
      var started = e.target;
      if (!started || started.tagName !== 'VIDEO') return;
      if (isAmbient(started)) {
        if (activeVideo && !activeVideo.paused) started.pause();
        return;
      }
      /* claim the slot BEFORE pausing the rest: their pause events fire async and
         would otherwise clear activeVideo straight back to null */
      activeVideo = started;
      $$('video').forEach(function (v) { if (v !== started && !v.paused) v.pause(); });
    }, true);

    document.addEventListener('pause', function (e) {
      if (e.target === activeVideo) activeVideo = null;
    }, true);
    document.addEventListener('ended', function (e) {
      if (e.target === activeVideo) activeVideo = null;
    }, true);
  }

  /* ---------- journey: scroll-linked timeline fill ---------- */
  function initJourney(root) {
    $$('[data-ihp-journey]', root).forEach(function (sec) {
      if (sec.dataset.ihpInit) return;
      sec.dataset.ihpInit = '1';
      var timeline = $('[data-journey-timeline]', sec);
      var fill = $('[data-journey-fill]', sec);
      var weeks = $$('[data-journey-week]', sec);
      if (!timeline || !fill) return;
      var ticking = false;
      function update() {
        ticking = false;
        var rect = timeline.getBoundingClientRect();
        var trigger = window.innerHeight * 0.55;
        var progress = (trigger - rect.top) / rect.height;
        progress = Math.max(0, Math.min(1, progress));
        fill.style.height = (progress * 100) + '%';
        weeks.forEach(function (w) {
          w.classList.toggle('is-active', w.getBoundingClientRect().top < trigger);
        });
      }
      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  }

  /* ---------- reveal-more buttons ---------- */
  function initReveals(root) {
    $$('[data-ihp-reveal-btn]', root).forEach(function (btn) {
      if (btn.dataset.ihpInit) return;
      btn.dataset.ihpInit = '1';
      btn.addEventListener('click', function () {
        var scope = btn.closest('[data-ihp-reveal-scope]') || document;
        $$('[data-reveal-hidden]', scope).forEach(function (el) { el.removeAttribute('data-reveal-hidden'); });
        var wrap = btn.parentElement;
        if (wrap) wrap.remove();
      });
    });
  }

  function initAll(root) {
    initCountdown(root); initGallery(root); initBuyBox(root); initKaching(root); initKachingNativeSync(root); initAccordions(root);
    initCounters(root); initReasons(root); initStrips(root); initVideos(root); initVideoSolo(); initVideoControls(root); initReveals(root);
    initJourney(root); initCompounds(root); initCardSliders(root); initStockBars(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
